import { useForm, FormContextInterface } from "../context";
import React, { useState, useEffect } from "react";
import { LinearProgress, styled } from "@mui/material";
import { getId } from '../data/formDefault'

const ScrollableElements = () => {
  const [visibleElement, setVisibleElement] = useState<string | null>(null);
  const [isManualScroll, setIsManualScroll] = useState<boolean>(false);

  useEffect(() => {
    // Add scroll event listener to window
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  const handleScroll = () => {
    const elements = [
      document.querySelector(`#${getId.addressDetails}`),
      document.querySelector(`#${getId.parentContent}`),
      document.querySelector(`#${getId.studentContent}`),
      document.querySelector(`#${getId.schoolDetails}`)
    ];

    const visibleElement1 = getVisibleElement(elements);
    setVisibleElement(visibleElement1 ? visibleElement1.id : null);
  };

  // Reset isManualScroll flag after 1 second
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsManualScroll(false);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [isManualScroll]);

  const progressBar = visibleElement === getId.addressDetails
    ? 75
    : visibleElement === getId.parentContent
    ? 50
    : visibleElement === getId.studentContent
    ? 25
    : false;

  return (
    <div>
      {progressBar && (
        <Progress
          sx={{ height: "5px" }}
          variant="determinate"
          value={progressBar}
        />
      )}
    </div>
  );
};

export default ScrollableElements;
const Progress = styled(LinearProgress)(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  zIndex: 9999
}));

const getVisibleElement = (elements: any) => {
  // Find the element that is closest to the center of the viewport
  const visibleElement = elements.reduce(
    (
      prev: { getBoundingClientRect: () => { (): any; new (): any; top: any; bottom: any } },
      curr: { getBoundingClientRect: () => { (): any; new (): any; top: any; bottom: any } }
    ) => {
      const prevTop = prev.getBoundingClientRect().top;
      const currTop = curr.getBoundingClientRect().top;
      const prevBottom = prev.getBoundingClientRect().bottom;
      const currBottom = curr.getBoundingClientRect().bottom;
      const prevDistance = Math.abs(window.innerHeight / 2 - (prevTop + prevBottom) / 2);
      const currDistance = Math.abs(window.innerHeight / 2 - (currTop + currBottom) / 2);
      return currDistance < prevDistance ? curr : prev;
    }
  );
  return visibleElement
}